// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".information-block[data-v-7529ac03]{padding:0 20px}#move-buttons[data-v-7529ac03],#move-point-description[data-v-7529ac03]{margin-bottom:10px;display:inline-block}#move-point-description[data-v-7529ac03]{margin-top:5px;font-style:italic}#move-point-description a.btn[data-v-7529ac03]{margin-top:5px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
